import { createBrowserRouter, Navigate } from "react-router";
import { Profile } from "./views/profile/Profile.tsx";
import { Home } from "./views/Home.tsx";
import { App } from "./App.tsx";
import { EditProfile } from "./views/profile/EditProfile.tsx";
import { CalendarPage } from "./views/profile/CalendarPage.tsx";
import { Search } from "./views/Search.tsx";
import { ScheduleSettings } from "./views/profile/ScheduleSettings.tsx";
import EditLocations from "./views/profile/EditLocations.tsx";
import Chats from "./views/profile/Chats.tsx";
import NewBookingPage from "./views/booking/NewBookingPage.tsx";
import NewSubscriptionPage from "./views/subscription/NewSubscriptionPage.tsx";
import UserBookingsPage from "./views/booking/UserBookingsPage.tsx";
import CancelBookingPage from "./views/booking/CancelBookingPage.tsx";
import MoveBookingPage from "./views/booking/MoveBookingPage.tsx";
import BookingDetailPage from "./views/booking/BookingDetailPage.tsx";
import TeacherDashboard from "./views/booking/TeacherDashboard.tsx";
import EditSingleLocation from "./views/profile/EditSingleLocation.tsx";
import Checkout from "./components/booking/Checkout.tsx";
import CheckoutSuccess from "./components/booking/CheckoutSuccess.tsx";
import CheckoutError from "./components/booking/CheckoutError.tsx";
import SubscriptionSuccessPage from "./views/subscription/SubscriptionSuccessPage.tsx";
import SubscriptionCheckout from "./components/subscription/SubscriptionCheckout.tsx";
import RefreshOnboardingPlaceholder from "./views/profile/RefreshOnboardingPlaceholder.tsx";
import TeacherLessonPrices from "./views/profile/TeacherLessonPrices.tsx";
import Privacy from "./views/legal/Privacy.tsx";
import Terms from "./views/legal/Terms.tsx";
import Impressum from "./views/legal/Impressum.tsx";
import FeedbackPage from "./views/feedback/FeedbackPage.tsx";
import ProtectedRoute from "./components/auth/ProtectedRoute.tsx";
import CallbackRoute from "./components/auth/CallbackRoute.tsx";
import MediaUpload from "./views/media/MediaUpload.tsx";
import Dashboard from "./views/Dashboard.tsx";
import MyStudio from "./views/MyStudio.tsx";
import NotFound from "./views/NotFound.tsx";

export const router = createBrowserRouter([
  {
    path: "/",
    Component: App,
    children: [
      {
        index: true,
        Component: Home,
      },
      {
        path: "login-callback",
        Component: CallbackRoute,
      },
      {
        Component: ProtectedRoute,
        children: [
          {
            path: "mystudio",
            Component: MyStudio,
            children: [
              {
                index: true,
                element: <Navigate to="dashboard" replace />,
              },
              {
                path: "dashboard",
                Component: Dashboard,
              },
              {
                path: "profile",
                Component: EditProfile,
              },
              {
                path: "bookings",
                Component: UserBookingsPage,
              },
              {
                path: "messages/:chatId?",
                Component: Chats,
              },
              {
                path: "teacher-dashboard",
                Component: TeacherDashboard,
              },
              {
                path: "locations",
                children: [
                  {
                    index: true,
                    Component: EditLocations,
                  },
                  {
                    path: ":locationId",
                    Component: EditSingleLocation,
                  },
                ],
              },
              {
                path: "schedules",
                Component: ScheduleSettings,
              },
              {
                path: "prices",
                Component: TeacherLessonPrices,
              },
            ],
          },
          {
            path: "teachers/:teacherId/bookings/new",
            Component: NewBookingPage,
          },
          {
            path: "teachers/:teacherId/subscriptions/new",
            Component: NewSubscriptionPage,
          },
          {
            path: "teachers/:teacherId/feedback",
            Component: FeedbackPage,
          },
          {
            path: "checkout/:bookingId",
            Component: Checkout,
          },
          {
            path: "checkout/:bookingId/success",
            Component: CheckoutSuccess,
          },
          {
            path: "checkout/:bookingId/error",
            Component: CheckoutError,
          },
          {
            path: "subscriptions/:subscriptionId/checkout",
            Component: SubscriptionCheckout,
          },
          {
            path: "subscriptions/:subscriptionId/success",
            Component: SubscriptionSuccessPage,
          },
          {
            path: "profile/:userId/edit",
            children: [
              {
                path: "onboarding/refresh",
                Component: RefreshOnboardingPlaceholder,
              },
            ],
          },
          {
            path: "profile/:userId/media/upload",
            Component: MediaUpload,
          },
          {
            path: "user/:userId/chats/:chatId?",
            element: <Navigate to="/mystudio/messages" replace />,
          },
          {
            path: "user/:userId/bookings/:bookingId",
            Component: BookingDetailPage,
          },
          {
            path: "user/:userId/bookings/:bookingId/cancel",
            Component: CancelBookingPage,
          },
          {
            path: "user/:userId/bookings/:bookingId/move",
            Component: MoveBookingPage,
          },
        ],
      },
      // Redirects for old paths
      {
        path: "dashboard",
        element: <Navigate to="/mystudio/dashboard" replace />,
      },
      {
        path: "backstage",
        element: <Navigate to="/mystudio/teacher-dashboard" replace />,
      },
      {
        path: "backstage/dashboard",
        element: <Navigate to="/mystudio/teacher-dashboard" replace />,
      },
      {
        path: "backstage/locations",
        element: <Navigate to="/mystudio/locations" replace />,
      },
      {
        path: "backstage/schedules",
        element: <Navigate to="/mystudio/schedules" replace />,
      },
      {
        path: "backstage/prices",
        element: <Navigate to="/mystudio/prices" replace />,
      },
      {
        path: "profile/:userId",
        Component: Profile,
      },
      {
        path: "profile/:userId/calendar",
        Component: CalendarPage,
      },
      {
        path: "search",
        Component: Search,
      },
      {
        path: "privacy",
        Component: Privacy,
      },
      {
        path: "terms",
        Component: Terms,
      },
      {
        path: "impressum",
        Component: Impressum,
      },
      {
        path: "*",
        Component: NotFound,
      },
      {
        path: "backoffice",
        children: [
          {
            path: "filters",
            lazy: () =>
              import("./views/backoffice/filters/ManageFilters.tsx").then(
                (m) => ({ Component: m.default }),
              ),
          },
        ],
      },
    ],
  },
]);
